import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { LocalStorageService } from "src/app/_services/localStorage/local-storage.service";
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ActionItemsGridRowRendererComponent } from '../../../../_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { AttendanceService } from '../../../../../_services/attendance/attendance.service'
import { HrService } from 'src/app/_services/hr-management/hr.service';
import { convertYYYYMMDDtoDDMMYYYY } from '../../../../../_helpers/utils';
@Component({
  selector: 'app-hrtimesheetapproval',
  templateUrl: './hrtimesheetapproval.component.html',
  styleUrls: ['./hrtimesheetapproval.component.scss']
})
export class HrtimesheetapprovalComponent implements OnInit {
  rowData: any;
  public columnDefs: ColDef[];
  modeAction: number = 1; //1 - create // 2 - update
  // gridApi and columnApi
  private api: GridApi;
  private columnApi: ColumnApi;
  defaultColDef: any;
  rowSelection: any;
  tenantId: string;
  userDetails: any;
  form: FormGroup;
  attendanceDetailsForm: FormGroup;
  selectedRow: any;
  modalService: any;
  currentUser: any;
  jsonData: any;
  gridLength = 0;
  sampleGridFrameworkComponents: any;
  selectedCheckboxData = [];
  projectDetailList = [];
  deleteConfirmationMsg = 'Are you sure you want to delete';
  userId: number;
  tableDate : any[];
  date = new Date();
  firstDay: any;
  lastDay: any;

  constructor(
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private hrService: HrService,
  ) { 
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.attendanceDetailsForm = this.formBuilder.group({
      id: new FormControl(''),
      employeeId: new FormControl(''),
      startDate: new FormControl(''),
      endDate: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.tableDate = [];
    this.getHrLookup();
  }

  getHrLookup(){
    if(this.attendanceDetailsForm.get('startDate').value && this.attendanceDetailsForm.get('endDate').value){
      let startDate = this.attendanceDetailsForm.get('startDate').value;
      startDate = convertYYYYMMDDtoDDMMYYYY(startDate);
      let endDate = this.attendanceDetailsForm.get('endDate').value;
      endDate = convertYYYYMMDDtoDDMMYYYY(endDate);
      this.hrService.getHrLookup(0, startDate, endDate).subscribe((response) => {
        this.tableDate = [];
        Object.keys(response).forEach((key) => {
          if(response[key]['timesheets'].length > 0) {
            response[key]['timesheets'].forEach(e => this.tableDate.push(e)
            )
          }
        })
        this.rowData = this.tableDate
      });
    }
    else{
      this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
      let fMonth = this.firstDay.getMonth()+1;
      let firstDate = this.firstDay.getDate().toString().length === 1 ? "0"+this.firstDay.getDate().toString() : this.firstDay.getDate().toString();
      let firstMonth = fMonth.toString().length === 1 ? (("0"+fMonth).toString()) : (fMonth.toString());
      this.firstDay = this.firstDay.getFullYear() + '-' + firstMonth + '-' + firstDate;
      this.firstDay = convertYYYYMMDDtoDDMMYYYY(this.firstDay);
      
      this.lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
      let lMonth = this.lastDay.getMonth()+1;
      let lastDate = this.lastDay.getDate().toString().length === 1 ? "0"+this.lastDay.getDate().toString() : this.lastDay.getDate().toString();
      let lastmonth = (lMonth.toString()).length === 1 ? (("0"+lMonth).toString()) : (lMonth.toString());
      this.lastDay = this.lastDay.getFullYear() + '-' + lastmonth + '-' + lastDate;
      this.lastDay = convertYYYYMMDDtoDDMMYYYY(this.lastDay);
      
      this.hrService.getHrLookup(0, this.firstDay, this.lastDay).subscribe((response) => {
        Object.keys(response).forEach((key) => {
          if(response[key]['timesheets'].length > 0) {
             response[key]['timesheets'].forEach(e => this.tableDate.push(e)
            )
          }
        })
        this.rowData = this.tableDate
      })
    }
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }  

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

    // create column definitions  
    private createColumnDefs() {
      return [
        {
          headerName: 'Assigned To',
          field: 'assignedTo',
          filter: true,
          editable: false,
          sortable: true,
          valueGetter: (params) => {
            return params.data.assignedToName;
          },
        },
        {
          headerName: 'Project Name',
          field: 'projectName',
          filter: true,
          editable: false,
          sortable: true,
        },
        {
          headerName: 'Project Code',
          field: 'projectCode',
          filter: true,
          editable: false,
          sortable: true,
          hide: true,
        },
        {
          headerName: 'Project Manager Id',
          field: 'projectManagerId',
          filter: true,
          editable: false,
          sortable: true,
          hide: true,
        },
        {
          headerName: 'Description',
          field: 'description',
          filter: true,
          editable: false,
          sortable: true,
        },
        {
          headerName: 'Date',
          field: 'startDate',
          filter: true,
          editable: false,
          sortable: true,
        },
        {
          headerName: 'Approved Hours',
          field: 'approvedHours',
          filter: true,
          editable: false,
          sortable: true,
        },
        {
          headerName: 'Efficiency',
          field: 'efficiency',
          filter: true,
          editable: false,
          sortable: true,
          
        },
        {
          headerName: 'Total Hours',
          field: 'totalHours',
          filter: true,
          editable: false,
          sortable: true,
        },
        {
          headerName: 'Status',
          field: 'status',
          cellStyle: (params) => {
            if (params.value === 'Applied' || params.value === 'applied') {
              return { color: 'blue', 'font-weight': 'bold' };
            } else if (params.value === 'Submit' || params.value === 'submit') {
              return { color: 'orange', 'font-weight': 'bold' };
            } else if (params.value === 'Approved' || params.value === 'approved') {
              return { color: 'green', 'font-weight': 'bold' };
            } else if (params.value === 'Reject' || params.value === 'reject') {
              return { color: 'red', 'font-weight': 'bold' };
            } else if (
              params.value === 'Withdraw' ||
              params.value === 'withdraw'
            ) {
              return { color: 'grey', 'font-weight': 'bold' };
            }
            return null;
          },
          filter: true,
          editable: false,
          sortable: true,
        },
      ]
    }


  openTimesheetApproval() {
    this.router.navigate([this.tenantId + '/dashboard/hr/approval-hr/hrtimesheetapproval']);
  }
  
  openCompOffApproval() {
    this.router.navigate([this.tenantId + '/dashboard/hr/approval-hr/hrcomoffapproval']);
  }
  
  openRegularizations() {
    this.router.navigate([this.tenantId + '/dashboard/hr/approval-hr/hrregularizapproval']);
  }

  openLeaveApproval() {
    this.router.navigate([this.tenantId + '/dashboard/hr/approval-hr/approval-status-hr']);
  }

}
